module.exports = __webpack_public_path__ + "img/chemical-active.4cb8d5af.svg";